import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, GlobalSignalRListener, BaasicButton, BaasicConfirmModal, ScrollToTopButton, BaasicDraggableModal, BaasicModal, QueryDropdown, BasicCheckbox } from 'core/components';
import { MultiViewCalendar, DateInput } from '@progress/kendo-react-dateinputs';
import { PreviewLayout } from 'core/layouts';
import { ItemActionTriangle } from 'themes/components';
import { NikoFacilityOrderReasonForChangeModal, NikoFacilityOrderConfirmationModal, NikoFacilityOrderPatientTemplateNoteModal, ChangeClinicalStatusModal } from "application/niko-facility-order/components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Button, DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { moreVerticalIcon } from "@progress/kendo-svg-icons";
import { observer } from "mobx-react";
import { NikoPatientInformationBar, NikoPatientInsuranceQuestionModal, NikoPatientInsuranceInfoNoteModal, NikoPatientEligibilityStatusNoteModal, NikoTemplateCreateModal, NikoTemplateMissingProductNoteModal, NikoTemplateInvoiceNoteModal, NikoPatientStatusModal, NikoPatientTemplateItemCalculationModal, PatientTemplateClinicalStatusNoteModal } from "application/niko-patient/components";
import { toDate, dateFormatter } from "core/utils";
import { FacilityOrderTemplateNewFlowDeleteModal, FacilityOrderTemplateItemNewFlowDeleteQuestionModal } from "application/facility-order-new-flow/components";
import { NikoFacilityOrderUSIntakeFindAndReplaceModal } from 'application/niko-facility-order-us-intake/components';
import moment from 'moment';
import { NikoPatientTemplateClinicalEdit } from "application/niko-patient/components";

function NikoPatientSalesOrderTemplate({ nikoPatientSalesOrderViewStore }) {
	const {
		loaderStore,
		statusConfirmModal,
		nikoPatientDetails,
		nikoPatientInsuranceQuestionModal,
		nikoPatientInsuranceInfoNoteModal,
		nikoPatientEligibilityStatusNoteModal,
		patientTemplateClinicalStatusNoteModal,
		nikoTemplateCreateModal,
		nikoTemplateMissingProductNoteModal,
		nikoTemplateInvoiceNoteModal,
		patientTemplateDoNotSupplyModal,
		patientTemplateDiscontinuedModal,
		nikoPatientStatusModal,
		patientTemplateDeleteModal,
		nikoPatientTemplateItemCalculationModal,
		nikoFacilityOrderReasonForChangeModal,
		changeClinicalStatusModal,
		nikoPatientTemplateItemNewFlowDeleteQuestionModal,
		patientTemplateNoteModal,
		templateChangeConfirmModal,
		rootStore,
		id,
		signalRAction,
		nikoFacilityOrderUSIntakeFindAndReplaceModal,
		filterModal,
		queryUtility,
		facilityStore,
		patientStore,
		itemCategoryStore,
		applyFilters,
		setDosFilter,
		commitDosFilter,
		clearDosFilter,
		totalResults,
		showInactive,
		showInsurance,
		showClinical,
		inactiveResults,
		triggerShowInactive,
		triggerShowInsurance,
		triggerShowClinical,
		setEditMode,
		clearFilters,
		tempDosFilter,
		isFilterApplyAvailable,
		clinicalLoadingCount,
		loadingFilter,
		billingValidationStore,
		isBiller,
		downloadPsoReport
	} = nikoPatientSalesOrderViewStore;

	return (
		<PreviewLayout className="container container--new-flow" store={nikoPatientSalesOrderViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading}>
			<ReactTooltip positionStrategy="fixed" id="usIntakeTooltip" place="bottom" />
			<GlobalSignalRListener groupId={id} rootStore={rootStore} action={signalRAction} />
			<React.Fragment>
					<div className='u-mar--y--med u-flex--primary u-flex--space-between is-nested'>
						<h1 className='type--wgt--medium'>Patient Sales Orders</h1>
						<div className='u-flex u-flex--default u-flex--gap--4'>
							<div className={`u-flex u-flex--default`}>
								<div className="fake-title"></div>
								<button
									type="button"
									className={`toggle-switch ${showInactive ? "on" : "off"}`}
									onClick={() => triggerShowInactive()}
								>
									<span className="toggle-switch__circle"></span>
								</button>
								<span className="fake-label">Show Inactive</span>
							</div>

							<div className={`u-flex u-flex--default`}>
								<div className="fake-title"></div>
								<button
									type="button"
									className={`toggle-switch ${showInsurance ? "on" : "off"}`}
									onClick={() => triggerShowInsurance()}
								>
									<span className="toggle-switch__circle"></span>
								</button>
								<span className="fake-label">Show Insurance</span>
							</div>

							<div className={`u-flex u-flex--default`}>
								<div className="fake-title"></div>
								<button
									type="button"
									className={`toggle-switch ${showClinical ? "on" : "off"}`}
									onClick={() => triggerShowClinical()}
									disabled={clinicalLoadingCount > 0}
								>
									<span className="toggle-switch__circle"></span>
								</button>
								<span className="fake-label">Show Clinical</span>
							</div>
							<div>
								<DropDownButton
									svgIcon={moreVerticalIcon}
									onItemClick={(e) => { if (e.item.text === "Download PSO Report") downloadPsoReport(); }}
									buttonClass="btn btn--base btn--filter is-icon-only"
									popupSettings={{
										popupClass: "is-clean is-match-button",
										animate: false,
										anchorAlign: { horizontal: "right", vertical: "bottom" },
										popupAlign: { horizontal: "right", vertical: "top" }
									}}
								>
									<DropDownButtonItem text="Download PSO Report" />
								</DropDownButton>
							</div>
						</div>
					</div>
					<div className='u-mar--y--med u-flex--primary u-flex--space-between is-nested'>
						<div className='u-flex u-flex--default'>
						<ActiveFilters nikoPatientSalesOrderViewStore={nikoPatientSalesOrderViewStore} />
							<button type="text" className="btn btn--base btn--filter-niko" onClick={() => filterModal.open()}>
								<i className='u-icon u-icon--med u-icon--filter-o'></i>
								Edit Filters
							</button>
						</div>
					{nikoPatientDetails && nikoPatientDetails.length > 0 && <div>{totalResults} results ({inactiveResults} inactive)</div>}
					</div>

				{nikoPatientDetails.map(nikoPatientDetail =>  { return ( (showInactive || nikoPatientDetail.isActive) &&
					<NikoPatientTemplate
						key={nikoPatientDetail.id}
						nikoPatientSalesOrderViewStore={nikoPatientSalesOrderViewStore}
						nikoPatientDetail={nikoPatientDetail}
						showInactive={showInactive}
						setEditMode={setEditMode}
					/>);
				})
				}
			</React.Fragment>
			<BaasicConfirmModal modalParams={statusConfirmModal} />
			< BaasicDraggableModal modalParams={nikoPatientInsuranceQuestionModal} className="modal__content modal--med" >
				<NikoPatientInsuranceQuestionModal />
			</BaasicDraggableModal >
			<BaasicDraggableModal modalParams={nikoPatientInsuranceInfoNoteModal} className="modal__content modal--med">
				<NikoPatientInsuranceInfoNoteModal />
			</BaasicDraggableModal>
			<BaasicModal modalParams={nikoPatientEligibilityStatusNoteModal} className="modal__content modal--med" >
				<NikoPatientEligibilityStatusNoteModal />
			</BaasicModal >
			<BaasicModal modalParams={patientTemplateClinicalStatusNoteModal} className="modal__content modal--med">
				<PatientTemplateClinicalStatusNoteModal />
			</BaasicModal>
			<BaasicModal modalParams={nikoTemplateCreateModal} className="modal__content modal--xxlrg">
				<NikoTemplateCreateModal />
			</BaasicModal>
			<BaasicDraggableModal modalParams={nikoTemplateMissingProductNoteModal} className="modal__content modal--med">
				<NikoTemplateMissingProductNoteModal />
			</BaasicDraggableModal>
			<BaasicDraggableModal modalParams={nikoTemplateInvoiceNoteModal} className="modal__content modal--med">
				<NikoTemplateInvoiceNoteModal />
			</BaasicDraggableModal>
			<BaasicDraggableModal modalParams={patientTemplateDoNotSupplyModal} className="modal__content modal--med">
				<NikoFacilityOrderConfirmationModal />
			</BaasicDraggableModal>
			<BaasicDraggableModal modalParams={patientTemplateDiscontinuedModal} className="modal__content modal--med">
				<NikoFacilityOrderConfirmationModal />
			</BaasicDraggableModal>
			<BaasicModal modalParams={nikoPatientStatusModal} className="modal__content modal--med">
				<NikoPatientStatusModal />
			</BaasicModal>
			<BaasicModal modalParams={patientTemplateDeleteModal} className="modal__content modal--med">
				<FacilityOrderTemplateNewFlowDeleteModal />
			</BaasicModal>
			<BaasicDraggableModal modalParams={nikoPatientTemplateItemCalculationModal} className="modal__content modal--lrg">
				<NikoPatientTemplateItemCalculationModal />
			</BaasicDraggableModal>
			<BaasicModal modalParams={nikoFacilityOrderReasonForChangeModal} className="modal__content modal--lrg">
				<NikoFacilityOrderReasonForChangeModal />
			</BaasicModal>
			<BaasicModal modalParams={changeClinicalStatusModal} className="modal__content modal--med">
				<ChangeClinicalStatusModal />
			</BaasicModal>
			<BaasicModal modalParams={nikoPatientTemplateItemNewFlowDeleteQuestionModal} className="modal__content modal--med">
				<FacilityOrderTemplateItemNewFlowDeleteQuestionModal />
			</BaasicModal>
			<BaasicDraggableModal modalParams={patientTemplateNoteModal} className="modal__content modal--med">
				<NikoFacilityOrderPatientTemplateNoteModal />
			</BaasicDraggableModal>
			<BaasicConfirmModal modalParams={templateChangeConfirmModal} />
			<BaasicModal modalParams={nikoFacilityOrderUSIntakeFindAndReplaceModal} className="modal__content modal--xlrg">
				<NikoFacilityOrderUSIntakeFindAndReplaceModal />
			</BaasicModal>
			<BaasicModal wrapperClass="is-aside" modalParams={filterModal} className="modal__content modal--aside">
				<FilterModal queryUtility={queryUtility} facilityStore={facilityStore} patientStore={patientStore} itemCategoryStore={itemCategoryStore}
					dosFilter={tempDosFilter} setDosFilter={setDosFilter} commitDosFilter={commitDosFilter} clearDosFilter={clearDosFilter} loadingFilter={loadingFilter} applyFilters={applyFilters} clearFilters={clearFilters} isFilterApplyAvailable={isFilterApplyAvailable}
					isBiller={isBiller} billingValidationStore={billingValidationStore}
				/>
			</BaasicModal>
			<ScrollToTopButton />
		</PreviewLayout>
	)
}

NikoPatientSalesOrderTemplate.propTypes = {
	nikoPatientSalesOrderViewStore: PropTypes.object.isRequired
};

const NikoPatientTemplate = observer(({ nikoPatientSalesOrderViewStore, nikoPatientDetail }) => {
	const {
		disabled,
		inProgressStatusId,
		openNikoPatientInsuranceQuestionModal,
		openNikoPatientInsuranceInfoNoteModal,
		openNikoHealthPatient,
		updateNikoPatientInsuranceInfoNote,
		openNikoPatientEligibilityStatusNoteModal,
		openReasonForChangeModal,
    showInactive,
    setEditMode,
	noChangeStatusId,
	fetchInsuranceChangeHistory,
	insuranceChangeHistoryMap,
	showInsuranceChangeHistory
	} = nikoPatientSalesOrderViewStore;

  var ichVisible = showInsuranceChangeHistory === nikoPatientDetail.id;
  var ich = ichVisible ? (insuranceChangeHistoryMap[nikoPatientDetail.id] || {}) : {};

  var renderChangeHistory = function (fieldKey) {
      var entry = ich[fieldKey];
      if (!entry || !entry.userName) return null;
      var d = new Date(entry.eventDate + "Z");
      var fd = d.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
      return <span className="card--info">{entry.userName}, {fd}</span>;
  };

  const disabledPatientStatuses = ['Hospital', 'Discharged', 'Expired'];

	return (
		<React.Fragment>
			<ReactTooltip positionStrategy="fixed" id={"nikoPatientTooltip" + nikoPatientDetail.id} place="bottom" />
			<div className="card--tertiary u-mar--bottom--sml--alt is-grey">
				<div className={`u-flex u-flex--default u-flex--space-between u-flex--align--v--center card--tertiary__header`}>
					<div className="u-flex--default">
						<h4 className="card--tertiary__header__title">
							{nikoPatientDetail.nikoPatient.lastName && `${nikoPatientDetail.nikoPatient.lastName}`}
							{nikoPatientDetail.nikoPatient.lastName && nikoPatientDetail.nikoPatient.firstName && ', '}
							{nikoPatientDetail.nikoPatient.firstName && `${nikoPatientDetail.nikoPatient.firstName}`}
						</h4>
						{disabledPatientStatuses.includes(nikoPatientDetail.status) &&
						<div>
							<div className={`u-mar--left--med btn--disc__wrapper lrg ${nikoPatientDetail.status === 'Hospital' ? 'is-fr' : ''}`}>
							{nikoPatientDetail.status}
							</div>
						</div>
						}
						<NikoPatientInformationBar nikoPatient={nikoPatientDetail.nikoPatient} disabled={disabled || nikoPatientDetail.disabled} showVisibilityOption={true}  disableEditMode={true} />
					</div>
					<div className='u-flex u-flex--default u-flex--gap--8 u-flex--align--v--center'>
						{nikoPatientDetail.facility && nikoPatientDetail.facility.name && <div className="u-flex u-flex--default u-flex--gap--2-5 u-flex--align--v--center"><i className="u-icon u-icon--sml u-icon--new-facility u-icon--new-facility--dark"></i> {nikoPatientDetail.facility.name}</div>}
						{nikoPatientDetail.facilityOrder && nikoPatientDetail.facilityOrder.dateOfService && <div className="u-flex u-flex--default u-flex--gap--2-5 u-flex--align--v--center"><i className="u-icon u-icon--sml u-icon--date"></i> {moment(nikoPatientDetail.facilityOrder.dateOfService).format('MM/DD/YYYY')}</div>}
					</div>
				</div>
				<React.Fragment>
				{!disabledPatientStatuses.includes(nikoPatientDetail.status) && nikoPatientDetail.showInsurance &&
					<div className='niko__status__wrapper u-mar--right--status-low'>
						{nikoPatientDetail.isNew ?
						<div className={` ${disabled || nikoPatientDetail.disabled ? "is-disabled" : ""}`}>
							<div className="niko__status yellow no-bg">
							<div className="niko__status__holder">
								<Button className="niko__status__btn" icon="u-icon u-icon--xsml u-icon--persons--yellow" disabled={disabled || nikoPatientDetail.disabled}>NEW PATIENT</Button>
							</div>
							</div>
						</div>
						:
						nikoPatientDetail.insuranceStatusId === inProgressStatusId ?
							<div className="niko__status grey">
							<div className={`niko__status__holder not-assigned`}>
								<Button icon="u-icon u-icon--xxsml u-icon--info-fill u-mar--y--sml" className="niko__status__btn" > NOT ASSIGNED </Button>
							</div>
							</div>
							:
							<div className={`${disabled || nikoPatientDetail.disabled ? "is-disabled" : ""}`}>
							<div className={`niko__status yellow ${nikoPatientDetail.insuranceStatusId === noChangeStatusId ? "success" : "warning"}`}>
								<div className="niko__status__holder">
								<Button className={`niko__status__btn ${nikoPatientDetail.insuranceStatusId === noChangeStatusId ? "success" : "warning"}`}> {nikoPatientDetail.insuranceStatusId === noChangeStatusId ? "NO CHANGES" : "CHANGES"} </Button>
								</div>
							</div>
							</div>
						}
					</div>
				}
					<div className={`card--tertiary__body is-rounded is-niko btn--group__wrapper ${!nikoPatientDetail.showInsurance ? 'is-collapsed' : ''}`}>
						<CollapsibleSection collapsed={!nikoPatientDetail.showInsurance} setState={ () => nikoPatientDetail.setShowInsurance(nikoPatientDetail) } tooltipId={"insuranceExpandTooltip" + nikoPatientDetail.id} tooltipText={nikoPatientDetail.showInsurance ? "Collapse Insurance" : "Expand Insurance"}>
							<div>
								<div className="card--tertiary__flex">
									<div className="status--sqare__wrapper u-mar--left--xsml">
										<BaasicButton
											className="btn btn--base-plus btn--light btn--uppercase  no-click"
											label={nikoPatientDetail.eligibilityStatus ? nikoPatientDetail.eligibilityStatus.name : "Blank"}
											disabled={disabled || nikoPatientDetail.disabled}
										/>
										{nikoPatientDetail.eligibilityStatus && nikoPatientDetail.eligibilityStatus.name != "Eligible" &&
											<React.Fragment>
												<ReactTooltip positionStrategy="fixed" id={"patientTemplateEligibilityStatusNoteTooltip" + nikoPatientDetail.id} place="bottom" />
												<Button className="btn btn--link u-mar--left--tny" icon="u-icon u-icon--med u-icon--us-note" onClick={() => openNikoPatientEligibilityStatusNoteModal(nikoPatientDetail)} disabled={disabled || nikoPatientDetail.disabled} data-tooltip-content="Eligibility Status Note" data-tooltip-id={"patientTemplateEligibilityStatusNoteTooltip" + nikoPatientDetail.id} />
											</React.Fragment>
										}
									</div>
									<div className="card--tertiary__data">
										<div>
											<div className="card--tertiary__data__item">
												<div>Primary:</div>
												<div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.primaryActive.insurance.current && nikoPatientDetail.primaryActive.insurance.current.name}</div>
												{nikoPatientDetail.primaryActive.policyNo.current && <div>{nikoPatientDetail.primaryActive.policyNo.current}</div>}
											</div>
											{nikoPatientDetail.primaryInactive.insurance.current &&
												<div className="card--tertiary__data__item">
													<div>Inactive:</div>
													<div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.primaryInactive.insurance.current.name}</div>
													<div>{nikoPatientDetail.primaryInactive.policyNo.current && nikoPatientDetail.primaryInactive.policyNo.current}</div>
												</div>
											}
										</div>
										<div>
											<div className="card--tertiary__data__item">
												<div>Secondary:</div>
												<div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.secondaryActive.insurance.current && nikoPatientDetail.secondaryActive.insurance.current.name}</div>
												{nikoPatientDetail.secondaryActive.policyNo.current && <div>{nikoPatientDetail.secondaryActive.policyNo.current}</div>}
											</div>
											{nikoPatientDetail.secondaryInactive.insurance.current &&
												<div className="card--tertiary__data__item">
													<div>Inactive:</div>
													<div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.secondaryInactive.insurance.current.name}</div>
													<div>{nikoPatientDetail.secondaryInactive.policyNo.current && nikoPatientDetail.secondaryInactive.policyNo.current}</div>
												</div>
											}
										</div>
									</div>
									{nikoPatientDetail.insuranceQuestion &&
										<div className="u-flex u-flex--default u-flex--gap--2">
											<div className="card--tertiary__header__divider"></div>
											<Button className="btn btn--status--red u-mar--left--xsml" icon="u-icon u-icon--med-lrg u-icon--us-question-note--red" onClick={() => { openNikoPatientInsuranceQuestionModal(nikoPatientDetail) }} disabled={disabled || nikoPatientDetail.disabled} />
										</div>
									}
									<div className="u-flex u-flex--default u-align--h--right">
										<div className="btn--group">
											<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-insurance-external-link" onClick={() => openNikoHealthPatient(nikoPatientDetail.nikoPatient.remoteId)} disabled={disabled || nikoPatientDetail.disabled} data-tooltip-content="Niko" data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
											{!nikoPatientDetail.insuranceQuestion &&
												<React.Fragment>
													<ReactTooltip positionStrategy="fixed" id={"nikoPatientInsuranceQuestionTooltip" + nikoPatientDetail.id} place="bottom" />
													<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-question-note-sh" onClick={() => openNikoPatientInsuranceQuestionModal(nikoPatientDetail)} disabled={disabled || nikoPatientDetail.disabled} data-tooltip-content="Insurance Question" data-tooltip-id={"nikoPatientInsuranceQuestionTooltip" + nikoPatientDetail.id} />
												</React.Fragment>
											}
											<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-note" onClick={() => openNikoPatientInsuranceInfoNoteModal(nikoPatientDetail)} disabled={disabled || nikoPatientDetail.disabled} data-tooltip-content="Insurance Info Note" data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
											<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-edit" onClick={() => { openReasonForChangeModal(nikoPatientDetail) }} disabled={disabled || nikoPatientDetail.disabled} data-tooltip-content="Edit Insurances" data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
											{/* <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-history" onClick={() => openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal()} disabled={ disabled || nikoPatientDetail.disabled} data-tooltip-content="Change History" data-tooltip-id={"registerPatientBottomTip" + nikoPatientDetail.id} /> */}
											<div className="btn--group__divider"></div>
										</div>

										{nikoPatientDetail.patientTemplates.some(fot => fot.isPriorAuthNeeded) &&
											<BaasicButton
												type='button'
												className="btn btn--base-plus btn--light is-grey no-click u-mar--right--tny"
												label={`PAR ${nikoPatientDetail.patientTemplates.filter(fot => fot.isPriorAuthNeeded).length}/${nikoPatientDetail.patientTemplates.length}`}
												disabled={disabled || nikoPatientDetail.disabled}
											/>
										}
										<div className="status--sqare__wrapper" data-tooltip-content={!nikoPatientDetail.eligibilityStatusId ? "Eligibility Status must be selected" : ""} data-tooltip-id={!nikoPatientDetail.eligibilityStatusId ? `nikoPatientTooltip${nikoPatientDetail.id}` : ""}>
										</div>
									</div>
								</div>
								<div>
									{nikoPatientDetail.insuranceInfoNote &&
										<div className="c-message has-input c-message--note u-mar--top--sml">
											<i className="u-icon u-icon--sml u-icon--add-note" />
											<input
												className="input input--sml input--message u-flex--grow--1 type--sml"
												onClick={(e) => e.target.select()}
												onChange={(e) => { updateNikoPatientInsuranceInfoNote(nikoPatientDetail, e.target.value) }}
												onBlur={(e) => { updateNikoPatientInsuranceInfoNote(nikoPatientDetail, e.target.value, true) }}
												value={nikoPatientDetail.tempInsuranceInfoNote}
												disabled={disabled || nikoPatientDetail.disabled}
											/>
										</div>
									}
									{((!nikoPatientDetail.isInsuranceReviewed && nikoPatientDetail.note) || nikoPatientDetail.hasHistory) &&
                    <div className={`u-mar--top--lrg c-message has-dom-badge ${!nikoPatientDetail.isNew ? 'c-message--orange' : 'c-message--note--primary c-message--note--primary--tab'}`}>
                      {(!nikoPatientDetail.isInsuranceReviewed && nikoPatientDetail.note) &&
                        <React.Fragment>
                        <div className='c-message__badge'>
                              <i className='u-icon u-icon--size--badge u-icon--info-fill--neg'
                                onMouseEnter={() => { fetchInsuranceChangeHistory(nikoPatientDetail); nikoPatientSalesOrderViewStore.setShowInsuranceChangeHistory(nikoPatientDetail.id); }}
                                onMouseLeave={() => { nikoPatientSalesOrderViewStore.setShowInsuranceChangeHistory(null); }}>
                              </i>
                          </div>
                        <div className={`has-input ${nikoPatientDetail.isNew || !nikoPatientDetail.hasHistory ? '' : 'c-message--has-border'} u-flex--align-center is-center u-flex--default u-flex--gap--1 w--100`} >
                          Note: <p style={{ fontWeight: "normal" }}>{nikoPatientDetail.note}</p>
                          <span className="card--info__wrap">{renderChangeHistory("Note")}</span>
                          {nikoPatientDetail.effectiveDate &&
                            <span className="u-align--h--right type--whitespace--nowrap">Effective Date: {toDate(nikoPatientDetail.effectiveDate)}</span>
                          }
                        </div>
                        </React.Fragment>
                      }
					{!nikoPatientDetail.isNew &&
						<React.Fragment>
                      <div className='c-message__badge'>
                          Changes
                          <i className='u-icon u-icon--size--badge u-icon--info-fill--neg'
                            onMouseEnter={() => { fetchInsuranceChangeHistory(nikoPatientDetail); nikoPatientSalesOrderViewStore.setShowInsuranceChangeHistory(nikoPatientDetail.id); }}
                            onMouseLeave={() => { nikoPatientSalesOrderViewStore.setShowInsuranceChangeHistory(null); }}>
                          </i>
                      </div>
                          {nikoPatientDetail.primaryActive.insuranceId.current != nikoPatientDetail.primaryActive.insuranceId.initial &&
                            <div className="u-flex--default u-flex--gap--2 c-message--content">
                              <p className="type--sml"><b>Primary Active Changed</b></p>
                              <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.primaryActive.insurance.initial ? nikoPatientDetail.primaryActive.insurance.initial.Name : "Empty"}</b></label>
                              <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                              <p className="type--sml"><b>{nikoPatientDetail.primaryActive.insurance.current ? nikoPatientDetail.primaryActive.insurance.current.name : "Empty"}</b></p>
                              <span className="card--info__wrap">{renderChangeHistory("PrimaryActiveInsuranceId")}</span>
                            </div>
                          }
                          {nikoPatientDetail.primaryActive.insuranceId.current == nikoPatientDetail.primaryActive.insuranceId.initial && nikoPatientDetail.primaryActive.policyNo.current != nikoPatientDetail.primaryActive.policyNo.initial &&
                            <div className="u-flex--default u-flex--gap--2 c-message--content">
                              <p><b>Primary Active Policy Number Changed</b></p>
                              <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.primaryActive.policyNo.initial}</b></label>
                              <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                              <p className="type--sml"><b>{nikoPatientDetail.primaryActive.policyNo.current}</b></p>
                              <span className="card--info__wrap">{renderChangeHistory("PrimaryActivePolicyNo")}</span>
                            </div>
                          }
                          {nikoPatientDetail.primaryInactive.insuranceId.current && nikoPatientDetail.primaryInactive.insuranceId.current != nikoPatientDetail.primaryInactive.insuranceId.initial &&
                            <div className="u-flex--default u-flex--gap--2 c-message--content">
                              <p className="type--sml"><b>Primary Inactive Changed</b></p>
                              <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.primaryInactive.insurance.initial ? nikoPatientDetail.primaryInactive.insurance.initial.Name : "Empty"}</b></label>
                              <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                              <p className="type--sml"><b>{nikoPatientDetail.primaryInactive.insurance.current.name}</b></p>
                              <span className="card--info__wrap">{renderChangeHistory("PrimaryInactiveInsuranceId")}</span>
                            </div>
                          }
                          {nikoPatientDetail.primaryInactive.insuranceId.current && nikoPatientDetail.primaryInactive.insuranceId.current == nikoPatientDetail.primaryInactive.insuranceId.initial && nikoPatientDetail.primaryInactive.policyNo.current != nikoPatientDetail.primaryInactive.policyNo.initial &&
                            <div className="u-flex--default u-flex--gap--2 c-message--content">
                              <p className="type--sml"><b>Primary Inactive Policy Number Changed</b></p>
                              <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.primaryInactive.policyNo.initial}</b></label>
                              <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                              <p className="type--sml"><b>{nikoPatientDetail.primaryInactive.policyNo.current}</b></p>
                              <span className="card--info__wrap">{renderChangeHistory("PrimaryInactivePolicyNo")}</span>
                            </div>
                          }
                          {nikoPatientDetail.secondaryActive.insuranceId.current != nikoPatientDetail.secondaryActive.insuranceId.initial &&
                            <div className="u-flex--default u-flex--gap--2 c-message--content">
                              <p className="type--sml"><b>Secondary Active Changed</b></p>
                              <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.secondaryActive.insurance.initial ? nikoPatientDetail.secondaryActive.insurance.initial.Name : "Empty"}</b></label>
                              <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                              <p className="type--sml"><b>{nikoPatientDetail.secondaryActive.insurance.current ? nikoPatientDetail.secondaryActive.insurance.current.name : "Empty"}</b></p>
                              <span className="card--info__wrap">{renderChangeHistory("SecondaryActiveInsuranceId")}</span>
                            </div>
                          }
                          {nikoPatientDetail.secondaryActive.insuranceId.current == nikoPatientDetail.secondaryActive.insuranceId.initial && nikoPatientDetail.secondaryActive.policyNo.current != nikoPatientDetail.secondaryActive.policyNo.initial &&
                            <div className="u-flex--default u-flex--gap--2 c-message--content">
                              <p className="type--sml"><b>Secondary Active Policy Number Changed</b></p>
                              <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.secondaryActive.policyNo.initial}</b></label>
                              <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                              <p className="type--sml"><b>{nikoPatientDetail.secondaryActive.policyNo.current}</b></p>
                              <span className="card--info__wrap">{renderChangeHistory("SecondaryActivePolicyNo")}</span>
                            </div>
                          }
                          {nikoPatientDetail.secondaryInactive.insuranceId.current && nikoPatientDetail.secondaryInactive.insuranceId.current != nikoPatientDetail.secondaryInactive.insuranceId.initial &&
                            <div className="u-flex--default u-flex--gap--2 c-message--content">
                              <p className="type--sml"><b>Secondary Inactive Changed</b></p>
                              <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.secondaryInactive.insurance.initial ? nikoPatientDetail.secondaryInactive.insurance.initial.Name : "Empty"}</b></label>
                              <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                              <p className="type--sml"><b>{nikoPatientDetail.secondaryInactive.insurance.current.name}</b></p>
                              <span className="card--info__wrap">{renderChangeHistory("SecondaryInactiveInsuranceId")}</span>
                            </div>
                          }
                          {nikoPatientDetail.secondaryInactive.insuranceId.current && nikoPatientDetail.secondaryInactive.insuranceId.current == nikoPatientDetail.secondaryInactive.insuranceId.initial && nikoPatientDetail.secondaryInactive.policyNo.current != nikoPatientDetail.secondaryInactive.policyNo.initial &&
                            <div className="u-flex--default u-flex--gap--2 c-message--content">
                              <p className="type--sml"><b>Secondary Inactive Policy Number Changed</b></p>
                              <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.secondaryInactive.policyNo.initial}</b></label>
                              <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                              <p className="type--sml"><b>{nikoPatientDetail.secondaryInactive.policyNo.current}</b></p>
                              <span className="card--info__wrap">{renderChangeHistory("SecondaryInactivePolicyNo")}</span>
                            </div>
                          }
                          {nikoPatientDetail.eligibilityStatusId != (nikoPatientDetail.initialNikoPatientDetail ? nikoPatientDetail.initialNikoPatientDetail.EligibilityStatusId : null) &&
                            <div className="u-flex--default u-flex--gap--2 c-message--content">
                              <p className="type--sml"><b>Insurance status changed</b></p>
                              <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.EligibilityStatus ? nikoPatientDetail.initialNikoPatientDetail.EligibilityStatus.Name : "Empty"}</b></label>
                              <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                              <p className="type--sml"><b>{nikoPatientDetail.eligibilityStatus ? nikoPatientDetail.eligibilityStatus.name : "Empty"}</b></p>
                              <span className="card--info__wrap">{renderChangeHistory("EligibilityStatusId")}</span>
                            </div>
                          }
                          {nikoPatientDetail.patientTemplates.map(pt => {
                            return (!pt.isNew && (pt.isPriorAuthNeeded ? true : false) != (pt.initialPatientTemplate && pt.initialPatientTemplate.IsPriorAuthNeeded ? true : false) &&
                              <div key={pt.id + "-par"} className="u-flex--default u-flex--gap--2 c-message--content">
                                <p className="type--sml"><b>{`${pt.subCategory.name} template ${pt.portalId} PAR changed`}</b></p>
                                <label className="type--sml type--color--opaque"><b>{pt.initialPatientTemplate && pt.initialPatientTemplate.IsPriorAuthNeeded ? "TRUE" : "FALSE"}</b></label>
                                <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                                <p className="type--sml"><b>{pt.isPriorAuthNeeded ? "TRUE" : "FALSE"}</b></p>
                                <span className="card--info__wrap">{renderChangeHistory("PAR_" + pt.id)}</span>
                              </div>
                            );
                          })
                          }
                      </React.Fragment>
						}
						</div>
									}
								</div>
							</div>
						</CollapsibleSection>
					</div>
				</React.Fragment>
				<div className="card--tertiary__body u-padd--top--0">
					{
						nikoPatientDetail.patientTemplates.map(patientTemplate => {
						return (
							(showInactive || !patientTemplate.isDiscontinued) &&
							<PatientTemplateTable
								key={patientTemplate.id}
								nikoPatientSalesOrderViewStore={nikoPatientSalesOrderViewStore}
								patientTemplate={patientTemplate}
								nikoPatientDetail={nikoPatientDetail}
								setEditMode={setEditMode}
								isPatientDisabled={disabledPatientStatuses.includes(nikoPatientDetail.status)}
							/>
						);
						})
					}
				</div>
			</div>
		</React.Fragment>
	);
});

NikoPatientTemplate.propTypes = {
	nikoPatientSalesOrderViewStore: PropTypes.object.isRequired,
	nikoPatientDetail: PropTypes.object.isRequired
};

const PatientTemplateTable = observer(({ nikoPatientSalesOrderViewStore, patientTemplate, nikoPatientDetail, isPatientDisabled }) => {
	const {
		disabled,
		inProgressStatusId,
		changeStatusId,
		noChangeStatusId,
		dischargeStatusId,
		insertImportActionId,
		deleteImportActionId,
		openPatientTemplateMissingProductNoteModal,
		openPatientTemplateInvoiceNoteModal,
		openPatientTemplateNoteModal,
		getFieldHistory,
		// setEditMode, // ISG-2532: edit mode removed - no longer consumed after the Edit Mode toolbar icon was removed
		completeTemplateValidation,
		rentalsCapped,
		isBiller,
		goToNikoHealthSalesOrder,
		goToNikoHealthInvoice
	} = nikoPatientSalesOrderViewStore;

	const TooltipContent = observer(({ initianValue, history, fieldName }) => {
    if (!history || history.fieldName !== fieldName) return null;

		const date = new Date(history.eventDate + "Z");
		const formattedDate = date.toLocaleString('en-US', {
			month: '2-digit',
			day: '2-digit',
			year: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			hour12: true
		}).replace(',', '');

		if (fieldName === 'ImportAction') {
			return (<div>
				<div>{history.action} by {history.userName}</div>
				<div style={{ fontSize: '11px', opacity: 0.75 }}>{formattedDate}</div>
			</div>);
		}
		return (<div>
			<div>Previous: {initianValue ? initianValue : 'blank'}</div>
			<div style={{ fontSize: '11px', opacity: 0.75 }}>
				{history ? history.userName + ' ' + formattedDate : '—'}
			</div>
		</div>)
	});

	let templateStatusHolderStyle = '';
	let tableWrapperStyle = '';
	if (patientTemplate.intakeStatusId === noChangeStatusId){
		templateStatusHolderStyle = 'success';
		tableWrapperStyle = 'success';
	}
	else if (patientTemplate.intakeStatusId === changeStatusId){
		templateStatusHolderStyle = 'warning';
		tableWrapperStyle = 'warning-triangle';
}
	else if (patientTemplate.intakeStatusId === dischargeStatusId){
		templateStatusHolderStyle = 'danger';
		tableWrapperStyle = 'danger';
	}

	if (patientTemplate.isDiscontinued || isPatientDisabled)
		tableWrapperStyle = 'danger';
	else if (patientTemplate.isNew)
		tableWrapperStyle = 'new';

	const showInvoiceNote = nikoPatientDetail.facility
		&& nikoPatientDetail.facility.sendAgoraPo === false
		&& nikoPatientDetail.facility.nikoMasterPatientId
		&& nikoPatientDetail.facility.nikoMasterPatientId == nikoPatientDetail.nikoPatientId;
	const isMasterPatient = Boolean(nikoPatientDetail.facility
		&& nikoPatientDetail.facility.nikoMasterPatientId
		&& nikoPatientDetail.facility.nikoMasterPatientId == nikoPatientDetail.nikoPatientId);
	const showHeaderActionButton = patientTemplate.note || showInvoiceNote;

	return (
		<React.Fragment>
			<ReactTooltip positionStrategy="fixed" id={"patientTemplateTooltip" + patientTemplate.id} place="bottom" />
			<div className='niko__status__wrapper '>
				{!isPatientDisabled &&
					(patientTemplate.isNew ?
					<div className={`u-mar--right--status-top  ${disabled || nikoPatientDetail.disabled ? "is-disabled" : ""}`}>
						<div className="niko__status no-bg yellow">
							<div className="niko__status__holder">
								<Button className="niko__status__btn" icon="u-icon u-icon--xsml u-icon--box--yellow" onClick={() => { }} disabled={disabled || nikoPatientDetail.disabled}>NEW ORDER</Button>
							</div>
						</div>
					</div>
					:
					patientTemplate.intakeStatusId === inProgressStatusId ?
						<div className="niko__status grey u-mar--right--status-top">
							<div className={`niko__status__holder not-assigned`}>
								<Button
									icon="u-icon u-icon--xxsml u-icon--info-fill u-mar--y--sml"
									className="niko__status__btn"
									onClick={() => { }}
								>
									NOT ASSIGNED
								</Button>
							</div>
						</div>
						:
						<div className={` u-mar--right--status-top ${disabled || nikoPatientDetail.disabled ? "is-disabled" : ""}`}>
							<div className={`niko__status ${templateStatusHolderStyle}`}>
								{patientTemplate.intakeStatusId !== dischargeStatusId &&
								<div className="niko__status__holder ">
									<Button
									className={`niko__status__btn ${templateStatusHolderStyle}`}
									onClick={() => { }}
									disabled={disabled || nikoPatientDetail.disabled}
									>
									{`${patientTemplate.intakeStatusId === noChangeStatusId ? "NO CHANGES" : patientTemplate.intakeStatusId === changeStatusId ? "CHANGES" : ""}`}
									</Button>
								</div>
								}
							</div>
						</div>
					)}
			</div>

			<div className={`table--secondary__wrapper no-hover-line u-mar--bottom--med--condition is-niko ${patientTemplate.isDiscontinued && nikoPatientDetail.status == "Active" ? 'is-add-new-disabled' : ''} ${tableWrapperStyle} ${ disabled || nikoPatientDetail.disabled || (patientTemplate.patientTemplateItems && patientTemplate.patientTemplateItems.some(x => !x.productId)) ? 'is-add-new-disabled' : ''}`}>
				{/* <ReactTooltip positionStrategy="fixed" id={"registerTemplateTip" + facilityOrderTemplate.id} place="bottom" /> */}
				<table className="table--secondary w--100">
					<colgroup>
						<col width={400} />
						<col width={150} />
						<col width={80} />
						<col width={70} />
						{patientTemplate.isDifferentQty && patientTemplate.patientTemplateItems.length > 0 && <col width={70} />}
						<col />

					</colgroup>
					<thead>
						<tr>
							<th colSpan={patientTemplate.isDifferentQty && patientTemplate.patientTemplateItems.length > 0 ? 6 : 5} className="btn--group__wrapper">
								<div className="u-flex--space-between">
									<label>{patientTemplate.subCategory.name.toUpperCase()}</label>
									{patientTemplate.isEligibleToSend != null && nikoPatientDetail.status == "Active" && !patientTemplate.isDiscontinued && !patientTemplate.isUserDns && !patientTemplate.isSystemDns && patientTemplate.patientTemplateItems.some(x => x.productId && x.actionId != deleteImportActionId && x.salesOrderQuantity > 0) &&
										<div className="u-mar--left--xsml u-mar--bottom--tny" data-tooltip-content={!patientTemplate.isEligibleToSend && patientTemplate.nextSendDate ? `Next Send Date: ${toDate(patientTemplate.nextSendDate)}` : null} data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id}>
											{patientTemplate.isEligibleToSend ? <i className="u-icon u-icon--med u-icon--calendar-yes--dark" /> : <i className="u-icon u-icon--med u-icon--calendar-x--dark" />}
										</div>
									}
									{patientTemplate.isDiscontinued &&
										<div>
											<div className="u-mar--left--xsml btn--disc__wrapper">
												Discontinued
											</div>
										</div>
									}
									{patientTemplate.isUserDns &&
										<div>
											<div className="u-mar--left--xsml btn--disc__wrapper is-fr">
												Do not supply - FR

											</div>
										</div>
									}
									{patientTemplate.isSystemDns &&
										<div>
											<div className="u-mar--left--xsml btn--disc__wrapper is-fr">
												Do not supply
											</div>
										</div>
									}
									{
										patientTemplate.missingProductNote &&
										<React.Fragment>
											<Button className="btn btn--status--red u-mar--left--xsml" icon="u-icon u-icon--med-lrg u-icon--missing-product" onClick={() => { openPatientTemplateMissingProductNoteModal(patientTemplate) }} disabled={disabled || nikoPatientDetail.disabled} />
										</React.Fragment>
									}
									{(patientTemplate.nikoOrderDisplayId || (patientTemplate.nikoInvoices && patientTemplate.nikoInvoices.length > 0)) &&
										<div className="u-mar--left--sml type--color--secondary">
											{patientTemplate.nikoOrderDisplayId &&
													<button className={`btn btn--link btn--link--underline`} onClick={() => goToNikoHealthSalesOrder(patientTemplate.nikoOrderId)}>{patientTemplate.nikoOrderDisplayId}</button>
												}
												{patientTemplate.nikoInvoices && patientTemplate.nikoInvoices.map((invoice, index) =>
													<button key={invoice.remoteId} className={`btn btn--link btn--link--underline ${(index > 0 || patientTemplate.nikoOrderDisplayId) ? 'u-mar--left--sml' : ''}`} onClick={() => goToNikoHealthInvoice(invoice.remoteId)}>{invoice.displayId}</button>
												)}
										</div>
									}
									{
										<div className="card--tertiary__header__actions u-align--h--right">
											<div className="btn--group">
												{nikoPatientDetail.eligibilityStatus && nikoPatientDetail.eligibilityStatus.name == "Eligible" &&
													<React.Fragment>
														<div className="status--sqare__wrapper">
															<BaasicButton
																type='button'
																className="btn btn--base-plus btn--light btn--uppercase is-nonclickable"
																key={patientTemplate.clinicalStatusId} label={(patientTemplate.clinicalStatus && patientTemplate.clinicalStatus.name) || 'Unselected'}
																disabled={!patientTemplate.clinicalStatusId}
															/>
														</div>
														{showHeaderActionButton &&
															<div className="btn--group__divider"></div>
														}
													</React.Fragment>
												}
                        {showInvoiceNote &&
                          <Button className="btn no-hover" icon={"u-icon u-icon--med-lrg u-icon--us-invoice-note"} onClick={() => { openPatientTemplateInvoiceNoteModal(patientTemplate) }} data-tooltip-content="Invoice Note" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                        }
                        {patientTemplate.note &&
                          <Button className="btn no-hover" icon={"u-icon u-icon--med-lrg u-icon--danger-triangle--primary"} onClick={() => { openPatientTemplateNoteModal(patientTemplate) }} data-tooltip-content="View Note" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                        }
                        {/* ISG-2532: Edit Mode / Exit Edit Mode icon removed - clinical fields are now always editable.
                            Kept (commented) in case edit mode needs to be restored.
                        {patientTemplate.isEditDisabled ?
                          <Button className="btn no-hover" icon={"u-icon u-icon--med-lrg u-icon--us-edit"} onClick={() => { setEditMode(patientTemplate) }} data-tooltip-content="Edit Mode" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                        :
                          <Button className="btn no-hover" icon={"u-icon--lrg u-icon--med-lrg u-icon--edit-in-progress"} onClick={() => { setEditMode(patientTemplate) }} data-tooltip-content="Exit Edit Mode" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                        }
                        */}
											</div>
										</div>
									}
								</div>
							</th>
						</tr>
						{patientTemplate.facilityOrderTemplateValidations && patientTemplate.facilityOrderTemplateValidations.length > 0 &&
							<tr>
								<th colSpan={patientTemplate.isDifferentQty && patientTemplate.patientTemplateItems.length > 0 ? 6 : 5}>
									{patientTemplate.facilityOrderTemplateValidations
										.filter(item => {
											const billerOnlyAbrvs = ['start-rentals', 'rental-insurance-changed', 'stop-rentals', 'aob-validation', 'invoice-pump-rental-kit-both-items-missing', 'invoice-pump-rental-kit-first-item-missing', 'invoice-pump-rental-kit-second-item-missing', 'sales-order-failed-import', 'invoice-failed-import', 'invoice-sales-order-link-missing'];
											return isBiller || !billerOnlyAbrvs.includes(item.validation.abrv);
										})
										.map((item, index) => {
											const isFailedImport = item.validation && (item.validation.abrv === 'sales-order-failed-import' || item.validation.abrv === 'invoice-failed-import' || item.validation.abrv === 'invoice-sales-order-link-missing');
										return (
											<div key={"validation-" + item.id} className={`c-message--import ${item.isResolved ? "is-grey" : (item.validation && item.validation.abrv && (item.validation.abrv.startsWith("invoice-pump-rental-kit-") || isFailedImport) ? "is-red" : "is-yellow")} ${index > 0 ? "u-mar--top--med u-mar--bottom--sml" : "u-mar--bottom--sml"}`}>
												<div className="u-flex--default u-flex--gap--2">
													<i className="u-icon u-icon--med c-message--import__icon"></i>
													<div>{isFailedImport ? (item.notes || item.validation.name) : item.validation.name}</div>
													{!isFailedImport && item.notes && <a href={item.notes} target="_blank" rel="noopener noreferrer"><i className="u-icon u-icon--sml u-icon--expand"></i></a>}
												</div>
												<div className="u-flex--default u-flex--gap--2">
													{!nikoPatientDetail.nikoPatient.rentalsCapped && (item.validation.abrv === 'start-rentals' || item.validation.abrv === 'rental-insurance-changed' || item.validation.abrv === 'stop-rentals') && !item.isResolved &&
														<React.Fragment>
															<div className="c-message--import__label">Rentals Capped</div>
															<BasicCheckbox id={nikoPatientDetail.nikoPatientId} checked={false} onChange={async () => await rentalsCapped(nikoPatientDetail.nikoPatientId, patientTemplate.facilityOrderId, patientTemplate.nikoPatientDetailId)} />
														</React.Fragment>
													}
													<div className="c-message--import__label">{item.validation && item.validation.abrv && (item.validation.abrv.startsWith("invoice-pump-rental-kit-") || isFailedImport) ? "Updated Manually" : "Complete"}</div>
													<BasicCheckbox id={item.id} checked={item.isResolved} onChange={async () => await completeTemplateValidation(patientTemplate.id, item.id)} disabled={item.isResolved} />
												</div>
											</div>
										);
									})}
								</th>
							</tr>
						}
						<tr>
							<th className="table__label--sml"></th>
							<th className="table__label--sml"></th>
							<th className="table__label--sml"></th>
							<th className="table__label--sml">{patientTemplate.isDifferentQty && patientTemplate.patientTemplateItems.length > 0 && <span className="table__label--inner">TEMP QTY</span>}</th>
							{patientTemplate.isDifferentQty && patientTemplate.patientTemplateItems.length > 0 && <th className="table__label--sml"><span className="table__label--inner">SO QTY</span></th>}
						</tr>
					</thead>
					<tbody style={(patientTemplate.isSystemDns || patientTemplate.isUserDns) ? { opacity: "0.5" } : {}}>
						{patientTemplate.patientTemplateItems.map((item) => {

							return (
								<tr key={item.id} className={`${(!patientTemplate.isNew && item.actionId === insertImportActionId && !nikoPatientDetail.isNew) ? "new-row" : (item.actionId === deleteImportActionId ? "deleted-row" : "")}`}>
									<td className="table-col-input is-flex">
										{(item.actionId === insertImportActionId || item.actionId === deleteImportActionId) && (
											<React.Fragment>
												<ReactTooltip positionStrategy="fixed" id={"registerTipImportAction" + item.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={null} history={item.history} fieldName={"ImportAction"} />} />
												<ItemActionTriangle item={item} insertActionId={insertImportActionId} deleteActionId={deleteImportActionId} tooltipId={"registerTipImportAction" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'ImportAction', null)} />
											</React.Fragment>
										)}
										<React.Fragment>{item.product.description} <span className="table__icons-wrapper"> {!item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable"></i>} {(item.isBackordered != null ? item.isBackordered : item.product.backordered) && <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>}</span></React.Fragment>
									</td>
									<td>
										{item.product && item.product.itemId}
									</td>
									<td className="table-col-input text-align-left">
										{item.procedureCode}
									</td>
									<td className="table-col-input text-align-left has-input">
										{/* id={"templateQuantity-" + facilityOrderTemplate.id} */}
										<ReactTooltip positionStrategy="fixed" id={"registerTipQuantity" + item.id} place="top" delayShow={600} render={() => <TooltipContent initianValue={item.initialPatientTemplateItem && item.initialPatientTemplateItem.Quantity} history={item.history} fieldName="Quantity" />} />
										{!patientTemplate.isNew && !nikoPatientDetail.isNew && item.initialPatientTemplateItem && item.initialPatientTemplateItem.Quantity != item.quantity && item.actionId !== insertImportActionId &&
											<div className="table-col-input__notif opacity-50" data-tooltip-id={"registerTipQuantity" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'Quantity', item.quantity)} data-tooltip-content="" ></div>}
										{item.product &&
											<input
												className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
												value={item.quantity || item.quantity === 0 ? item.quantity : undefined}
												type="number"
												min="0"
												readOnly={true}
												disabled={disabled}
											/>
										}
										{(item.sendSeparatelyQuantity | 0) > 0 && <i className="u-icon u-icon--ss u-icon--sml table__icon--ss" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={item.sendSeparatelyQuantity} />}
									</td>
									{patientTemplate.isDifferentQty &&
									<td className="table-col-input text-align-left has-input">
										<ReactTooltip positionStrategy="fixed" id={"registerTipSalesOrderQuantity" + item.id} place="top" delayShow={600} render={() => <TooltipContent initianValue={item.initialPatientTemplateItem && item.initialPatientTemplateItem.SalesOrderQuantity} history={item.history} fieldName="SalesOrderQuantity" />} />
										{!patientTemplate.isNew && !nikoPatientDetail.isNew && item.initialPatientTemplateItem && item.initialPatientTemplateItem.SalesOrderQuantity != item.salesOrderQuantity && item.actionId !== insertImportActionId &&
											<div className="table-col-input__notif opacity-50" data-tooltip-id={"registerTipSalesOrderQuantity" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'SalesOrderQuantity', item.salesOrderQuantity)} data-tooltip-content="" ></div>}
										{item.product &&
											<input
												className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
												value={item.salesOrderQuantity}
												type="number"
												min="0"
												readOnly={true}
												disabled={disabled}
											/>
										}
									</td>}
									<td className="table-col-input">
										{/* <ReactTooltip positionStrategy="fixed" id={"registerTipItemChangedNote" + item.id} place="top" /> */}
										<ReactTooltip positionStrategy="fixed" id={"registerTipNote" + item.id} place="top" delayShow={600} render={() => <TooltipContent initianValue={item.initialPatientTemplateItem && item.initialPatientTemplateItem.Note} history={item.history} fieldName="Note" />} />
										{!patientTemplate.isNew && !nikoPatientDetail.isNew && item.initialPatientTemplateItem && item.initialPatientTemplateItem.Note != item.note && item.actionId !== insertImportActionId &&
											<div className="table-col-input__notif opacity-50" data-tooltip-id={"registerTipNote" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'Note', item.note)} data-tooltip-content="" ></div>}
											<input
												className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
												value={item.note}
												readOnly={true}
												disabled={disabled}
											/>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
				<CollapsibleSection collapsed={!patientTemplate.showClinical} setState={ () => patientTemplate.setShowClinical(patientTemplate) } tooltipId={"clinicalExpandTooltip" + patientTemplate.id} tooltipText={patientTemplate.showClinical ? "Collapse Clinical Info" : "Expand Clinical Info"} iconAbove>
					<NikoPatientTemplateClinicalEdit key={`${nikoPatientSalesOrderViewStore.refreshKey}-${patientTemplate.clinicalEditKey || ''}`}pageViewStore={{ pageViewStore: { ...nikoPatientSalesOrderViewStore.pageViewStore, nikoPatientDetail: nikoPatientDetail } }} patientTemplate={patientTemplate} isPso={true} canChangeClinicalStatus={true} isMasterPatient={isMasterPatient} />
				</CollapsibleSection>
			</div>
		</React.Fragment>
	);
});

class CollapsibleSection extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { children, collapsed, setState, tooltipId, tooltipText, iconAbove } = this.props;

		const icon = (
			<React.Fragment>
				{tooltipId && <ReactTooltip positionStrategy="fixed" id={tooltipId} place="left" />}
				<div onClick={() => setState()} className='card--expand--icon' data-tooltip-content={tooltipText} data-tooltip-id={tooltipId}>
					<span className={!collapsed ? "u-icon u-icon--med u-icon--arrow-up" : "u-icon u-icon--med u-icon--arrow-down"}></span>
				</div>
			</React.Fragment>
		);

		if (iconAbove) {
			return (
				<div className='card--expand card--expand--column'>
					<div className='card--expand--icon-row'>
						{icon}
					</div>
					<div className='card--expand--main'>{!collapsed && <div>{children}</div>}</div>
				</div>
			);
		}

		return (
			<div className='card--expand'>
				<div className='card--expand--main'>{!collapsed && <div>{children}</div>}</div>
				{icon}
			</div>
		);
	}
}

CollapsibleSection.propTypes = {
	children: PropTypes.node,
	setState: PropTypes.func,
	collapsed: PropTypes.bool,
	tooltipId: PropTypes.string,
	tooltipText: PropTypes.string,
	iconAbove: PropTypes.bool
};

// A keyboard DateInput emits a value on every keystroke, so the year is momentarily incomplete
// (e.g. 0000, which is below DateTime.MinValue and the backend cannot bind). Only treat a date as
// ready to commit once it carries a complete, representable 4-digit year.
const inRange = d => d && d.getFullYear() >= 1000 && d.getFullYear() <= 9999;

class DosDateRangePicker extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			pendingStart: props.value.start || null,
			pendingEnd: props.value.end || null,
			popupStyle: {}
		};
		this.inputRef = React.createRef();
		this.rootRef = React.createRef();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value.start !== this.props.value.start || prevProps.value.end !== this.props.value.end) {
			this.setState({ pendingStart: this.props.value.start, pendingEnd: this.props.value.end });
		}
	}

	computePopupStyle() {
		if (!this.inputRef.current) return {};
		const rect = this.inputRef.current.getBoundingClientRect();
		return { position: 'fixed', top: rect.bottom + 4, right: window.innerWidth - rect.right, zIndex: 10000 };
	}

	openPopup = () => {
		if (this.state.isOpen) return;
		this.setState({ isOpen: true, popupStyle: this.computePopupStyle() });
	}

	toggleOpen = () => {
		if (!this.state.isOpen) this.openPopup();
		else this.setState({ isOpen: false });
	}

	handleStartChange = (event) => {
		this.commitRange(event.value, this.state.pendingEnd);
	}

	handleEndChange = (event) => {
		this.commitRange(this.state.pendingStart, event.value);
	}

	// Propagate the pending range to the store (same onChange path as the calendar's Apply) so
	// partial/single-date selections stay in sync and can be cleared by "Clear all" — but only once any
	// present date has a complete, in-range year and the range is not inverted (start <= end), so transient
	// keystrokes (e.g. year 0000 or a momentarily inverted range) never fire a request. The store-side
	// reaction debounces these committed changes. Close the calendar only once both ends are valid dates.
	commitRange = (start, end) => {
		this.setState({ pendingStart: start, pendingEnd: end });
		if ((!start || inRange(start)) && (!end || inRange(end)) && (!start || !end || start <= end)) {
			this.props.onChange({ target: { value: { start, end } } });
			if (start && end) {
				this.setState({ isOpen: false });
			}
		}
	}

	handleKeyDown = (event) => {
		if (event.key === 'Enter') this.handleApply();
	}

	// Recompute the other filters / run the no-results check when the user leaves the whole
	// Dates picker. Ignore focus moves that stay inside it (From <-> To, into the calendar, Cancel) so
	// those never fire mid-edit; the value was already synced to the store on change (value-only).
	handleBlur = (event) => {
		if (this.rootRef.current && this.rootRef.current.contains(event.relatedTarget)) return;
		this.props.onCommit();
	}

	handleCalendarChange = (event) => {
		const range = event.value;
		if (!range) return;
		this.setState({ pendingStart: range.start, pendingEnd: range.end });
	}

	handleApply = () => {
		this.props.onChange({ target: { value: { start: this.state.pendingStart, end: this.state.pendingEnd } } });
		this.props.onCommit();
		this.setState({ isOpen: false });
	}

	handleCancel = () => {
		this.setState({ isOpen: false, pendingStart: this.props.value.start, pendingEnd: this.props.value.end });
	}

	handleClearStart = () => {
		this.setState({ pendingStart: null });
		this.props.onClear({ target: { value: { start: null, end: this.state.pendingEnd } } });
	}

	handleClearEnd = () => {
		this.setState({ pendingEnd: null });
		this.props.onClear({ target: { value: { start: this.state.pendingStart, end: null } } });
	}

	render() {
		const rangeValue = { start: this.state.pendingStart, end: this.state.pendingEnd };
		const dateFormat = dateFormatter.map('kendo-input-short');
		const formatPlaceholder = { year: 'year', month: 'month', day: 'day' };
		return (
			<div className="dos-daterange" ref={this.rootRef} onBlur={this.handleBlur}>
				<div className="dos-daterange__input dos-daterange__input--range" ref={this.inputRef} onKeyDown={this.handleKeyDown}>
					<div className="dos-daterange__field">
						<DateInput
							format={dateFormat}
							formatPlaceholder={formatPlaceholder}
							value={this.state.pendingStart}
							onFocus={this.openPopup}
							onChange={this.handleStartChange}
						/>
						{this.state.pendingStart &&
							<button type="button" className="dos-daterange__clear is-clear" onClick={this.handleClearStart} aria-label="Clear start date">
								<i className="u-icon u-icon--xsml u-icon--close--primary"></i>
							</button>
						}
					</div>
					<span className="dos-daterange__sep">-</span>
					<div className="dos-daterange__field">
						<DateInput
							format={dateFormat}
							formatPlaceholder={formatPlaceholder}
							value={this.state.pendingEnd}
							onFocus={this.openPopup}
							onChange={this.handleEndChange}
						/>
						{this.state.pendingEnd &&
							<button type="button" className="dos-daterange__clear is-clear" onClick={this.handleClearEnd} aria-label="Clear end date">
								<i className="u-icon u-icon--xsml u-icon--close--primary"></i>
							</button>
						}
					</div>
					<i className="u-icon dos-daterange__icon" onClick={this.toggleOpen}></i>
				</div>
				{this.state.isOpen && (
					<div className="dos-daterange__popup" style={this.state.popupStyle}>
						<MultiViewCalendar
							mode="range"
							views={1}
							value={rangeValue}
							onChange={this.handleCalendarChange}
						/>
						<div className="dos-daterange__actions">
							<button type="button" className="btn btn--med btn--secondary" onClick={this.handleCancel}>Cancel</button>
							<button type="button" className="btn btn--med btn--primary" onClick={this.handleApply}>Apply</button>
						</div>
					</div>
				)}
			</div>
		);
	}
}

DosDateRangePicker.propTypes = {
	value: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
	onCommit: PropTypes.func.isRequired,
	onClear: PropTypes.func.isRequired
};

class FilterModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false
        };
    }

    render() {
		return (
			<React.Fragment>
				<div className="u-flex--modal">
					<div className="modal__header">
						<h3 className='modal__header--title type--color--brand'>Filters</h3>
					</div>
					<div className="modal__body">
						{this.props.isBiller && (
							<React.Fragment>
								<div>
									<h4 className='modal__body__title type--color--brand u-mar--bottom--med'>Billing Validations</h4>
									<div className="form__group">
										<QueryDropdown queryUtility={this.props.queryUtility} store={this.props.billingValidationStore} propertyName="billingValidation" placeholder="Validation" />
									</div>
								</div>
								<div className='u-separator--popup--sml'></div>
							</React.Fragment>
						)}
						<div>
							<h4 className='modal__body__title type--color--brand u-mar--bottom--med'>Who</h4>
							<div className="form__group">
								<QueryDropdown queryUtility={this.props.queryUtility} store={this.props.patientStore} propertyName="patientId" placeholder="Patient" />
							</div>
							<div className="form__group">
								<QueryDropdown queryUtility={this.props.queryUtility} store={this.props.facilityStore} propertyName="facilityId" placeholder="Facility" />
							</div>
						</div>

						<div className='u-separator--popup--sml'></div>
						<div>
							<h4 className='modal__body__title type--color--brand u-mar--bottom--med'>When</h4>
							<div className="form__group">
								<div className="card--quaternary card--sml" style={{ padding: '10px 12px' }}>
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
										<h5 className='modal__body__title is-small type--color--brand' style={{ margin: 0 }}>Dates</h5>
										<i className={`u-icon u-icon--med ${this.state.isOpen ? 'u-icon--arrow-up' : 'u-icon--arrow-down'}`}></i>
									</div>
									{this.state.isOpen && (
										<div style={{ marginTop: '8px' }}>
											<DosDateRangePicker value={this.props.dosFilter} onChange={this.props.setDosFilter} onCommit={this.props.commitDosFilter} onClear={this.props.clearDosFilter} />
										</div>
									)}
								</div>
							</div>
						</div>

						<div className='u-separator--popup--sml'></div>
						<div>
							<h4 className='modal__body__title type--color--brand u-mar--bottom--med'>What</h4>
							<div className="form__group">
								<QueryDropdown queryUtility={this.props.queryUtility} store={this.props.itemCategoryStore} propertyName="itemCategoryId" placeholder="Category" />
							</div>
						</div>
					</div>
					<div className='modal__footer is-divided'>
						<button className='btn btn--med btn--modal-clear' onClick={()=> this.props.clearFilters()}>Clear all</button>
						<BaasicButton
							className='btn btn--med btn--primary'
							label="Apply Filters"
							onClick={() => this.props.applyFilters()}
							disabled={!this.props.isFilterApplyAvailable || this.props.loadingFilter}
							icon={this.props.loadingFilter ? 'u-icon u-icon--xmed u-icon--sync u-rotate--login' : 'u-display--none'}
						/>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

FilterModal.propTypes = {
	isOpen: PropTypes.bool,
	queryUtility: PropTypes.object,
	facilityStore: PropTypes.object,
	patientStore: PropTypes.object,
	itemCategoryStore: PropTypes.object,
	billingValidationStore: PropTypes.object,
	dosFilter: PropTypes.object,
	setDosFilter: PropTypes.func,
	commitDosFilter: PropTypes.func,
	clearDosFilter: PropTypes.func,
	applyFilters: PropTypes.func,
	clearFilters: PropTypes.func,
	isFilterApplyAvailable: PropTypes.bool,
	isBiller: PropTypes.bool,
	loadingFilter: PropTypes.bool
};

class ActiveFilters extends React.Component {
	constructor(props) {
		super(props);
	}

  render() {
    const viewStore = this.props.nikoPatientSalesOrderViewStore;

    const hasDosFilter = viewStore.dosFilter && (viewStore.dosFilter.start || viewStore.dosFilter.end);
    let filterDateLabel = '';
    if (hasDosFilter) {
      const startLabel = viewStore.dosFilter.start ? moment(viewStore.dosFilter.start).format('MM/DD/YYYY') : '';
      const endLabel = viewStore.dosFilter.end ? moment(viewStore.dosFilter.end).format('MM/DD/YYYY') : '';
      if (startLabel && endLabel)
        filterDateLabel = `${startLabel} - ${endLabel}`;
      else if (startLabel)
        filterDateLabel = `From ${startLabel}`;
      else if (endLabel)
        filterDateLabel = `To ${endLabel}`;
    }

    return (
      <div className="u-flex u-flex--default u-flex--wrap u-flex--gap--2-5">
        {viewStore.tempBillingValidation ? <div className="btn btn--base-plus btn--light no-click"><span style={{ fontWeight: 350 }}>Validation is</span>{viewStore.tempBillingValidation.name}</div> : null}
        {viewStore.tempPatient ? <div className="btn btn--base-plus btn--light no-click"><span style={{ fontWeight: 350 }}>Patient is</span>{viewStore.tempPatient.name}</div> : null}
        {viewStore.tempFacility ? <div className="btn btn--base-plus btn--light no-click"><span style={{ fontWeight: 350 }}>Facility is</span>{viewStore.tempFacility.name}</div> : null}
        {hasDosFilter ? <div className="btn btn--base-plus btn--light no-click"><span style={{ fontWeight: 350 }}>DOS is</span> {filterDateLabel}</div> : null}
        {viewStore.tempItemCategory ? <div className="btn btn--base-plus btn--light no-click"><span style={{ fontWeight: 350 }}>Category is</span>{viewStore.tempItemCategory.name}</div> : null}
      </div>
    );
  }
}

ActiveFilters.propTypes = {
  nikoPatientSalesOrderViewStore: PropTypes.object.isRequired
};

PatientTemplateTable.propTypes = {
	nikoPatientSalesOrderViewStore: PropTypes.object.isRequired,
	patientTemplate: PropTypes.object.isRequired,
	nikoPatientDetail: PropTypes.object.isRequired
};

export default defaultTemplate(NikoPatientSalesOrderTemplate);
